import { CircularProgress, withStyles } from "@material-ui/core"

export const LoadingIndicator = withStyles({
    root: {
        margin: 'auto',
    }
})(CircularProgress);
